var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffidavitDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7603 1.07617V6.81617C13.7603 7.61309 14.3791 8.24848 15.1319 8.24848H20.6284",
    stroke: "#E62B2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8853 26.9223H4.12844C2.6125 26.9223 1.375 25.6408 1.375 24.0469V3.95156C1.375 2.36848 2.60219 1.07617 4.12844 1.07617H13.75L20.6284 8.25925V24.0577C20.6284 25.6408 19.4013 26.9331 17.875 26.9331L17.8853 26.9223Z",
    stroke: "#E62B2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.7586V14",
    stroke: "#E62B2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.4315V20.5156",
    stroke: "#E62B2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffidavitDocument);
export default __webpack_public_path__ + "static/media/affidavit-document.9ed4d822d4a80013ccdbf8bde015448c.svg";
export { ForwardRef as ReactComponent };